import { SxProps, Theme } from '@mui/material';

export const sharedTabStyles: {
  tabButton: SxProps<Theme>;
  tabsContainer: SxProps<Theme>;
} = {
  tabButton: {
    '&.Mui-selected': {
      fontWeight: 'bold',
      color: '#000000',
      border: '2px solid transparent',
    },
    '&:focus-visible': {
      border: '2px solid var(--outline-color)',
      borderRadius: '8px',
    },
  },
  tabsContainer: {
    '& .MuiTabs-indicator': {
      backgroundColor: 'var(--accent-green-main)',
    },
  },
};
